export const baseHost = '/images'
// 文件上传路径
export const uploadPath = process.env.NODE_ENV === 'production' ? '/upload' : 'http://47.108.209.149:58080/upload'
